import React from "react";

import NavigationBar from "@/components/NavigationBar";
import LoadingWrapper from "@/components/Loading";
import { Box, Typography } from "@mui/material";

type LayoutProps = {
  children: React.ReactNode;
  isLoading?: boolean;
  hideFooter?: boolean;
};

const Footer = () => {
  return (
    <Box
      component={"footer"}
      sx={{
        py: 4,
        px: 2,
        mt: 4,
        borderTop: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      <Typography
        variant="body2"
        sx={{
          textAlign: "center",
          color: "text.secondary",
          fontSize: "0.75rem",
        }}
      >
        {new Date().getFullYear()} howisthe.surf
      </Typography>
    </Box>
  );
};

const Layout = ({ children, isLoading, hideFooter }: LayoutProps) => {
  return (
    <LoadingWrapper isLoading={isLoading}>
      <NavigationBar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "calc(100vh - 56px)",
        }}
      >
        <Box sx={{ flex: 1 }}>{children}</Box>
        {!hideFooter && <Footer />}
      </Box>
    </LoadingWrapper>
  );
};

export default Layout;
